import React from "react";
import SearchMeta from "./SearchMeta";
import CreditMeta from "./CreditMeta";
import DBMeta from "./DBMeta";

import { useSummary } from "../../lib/varSummary";

const Summary = () => {
    const { summary } = useSummary();
    return (
        <div className="main">
            <table>
                <tbody>
                    <tr>
                        <td className="summaryCell">{summary.totalFound !== 0 ? <SearchMeta /> : <div className="main">Loading...</div>}</td>
                        <td className="summaryCell">{summary.totalFound !== 0 ? <CreditMeta /> : <div className="main">Loading...</div>}</td>
                        <td className="summaryCell">{summary.totalFound !== 0 ? <DBMeta /> : <div className="main">Loading...</div>}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default Summary